import {useQuery} from "react-query";
import {http} from "@firefly/fly-http";
// import omitUndefined from "../../util/omitUndefined";
import {omitUndefined} from "@firefly/fly-defter";

export function useGameContactQuery(uid: string | undefined) {
    return useQuery({
        enabled: !!uid,
        queryKey: ["viewer", uid, "verify-mobile", 'verified'],
        queryFn: () => {
            return http.get(`/api/wangame/viewer/game-vip/verify-mobile/verified`, omitUndefined({
            }))
        }
    })
}